<!-- Heading Title -->
<div class="heading-title-section" [style]="style" [class]="class">
  <h2  [ngClass]="mainiheading" class="heading-title"  [style]="headingStyle">{{ heading }}</h2>
  <h2 *ngIf="title"  [ngClass]="mainheading" class="heading-main-title"> {{ title }}</h2>
  <h3 class="heading-desc" [ngClass]="sectionheading" [style]="descriptionstyle" [innerHTML]="description"></h3>

</div>
<!-- Heading Title END -->